import React, { useEffect, useState } from 'react';
import { Phone, FileText } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Home.css';

const navItems = [
 { id: 'home', label: 'Home' },
 { id: 'about', label: 'About' },
 { id: 'services', label: 'Services' },
 { id: 'projects', label: 'Projects' },
 { id: 'contact', label: 'Contact' }
];

const bgImages = [
 // 1. Unsplash: Construction site with sky (via Google Image Search)
 'https://images.unsplash.com/photo-1429497419816-9ca5cfb4571a?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29uc3RydWN0aW9ufGVufDB8fDB8fHww',
 // 2. Dreamstime: Construction site at sunset (via Google Image Search)
 'https://thumbs.dreamstime.com/b/high-resolution-photo-modern-construction-site-sunset-showcasing-workers-silhouetted-against-vibrant-sky-scene-captures-378552107.jpg',
 // 3. Adobe Stock: Workers with blueprints (via Google Image Search)
 'https://t4.ftcdn.net/jpg/00/68/63/23/360_F_68632352_kmHLwFc2rQLmnKqn6gM0bhOPqxRTx8sY.jpg',
 // 4. iStock: Construction industry and engineering (via Google Image Search)
 'https://media.istockphoto-1345384816/photo/construction-industry-and-engineering-in-post-recession-period.jpg?s=612x612&w=0&k=20&c=3sK6hLkePixyVhbjrSDKATOx9cVnbor2d2qASBkUucM=',
 // 5. Outsourcing Hub India: Construction problems (via Google Image Search)
 'https://www.outsourcinghubindia.com/wp-content/uploads/2021/08/construction-accounting-problems.jpg',
 // 6. Repeat image for smooth transition cycle
 'https://images.unsplash.com/photo-1429497419816-9ca5cfb4571a?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y29uc3RydWN0aW9ufGVufDB8fDB8fHww', 
];

const Home = () => {
 const [isVisible, setIsVisible] = useState(false);
 const [isScrolled, setIsScrolled] = useState(false);
 // Removed isMobileMenuOpen state as mobile menu is being removed from layout
 const [currentImageIndex, setCurrentImageIndex] = useState(0);

 const navigate = useNavigate();
 const location = useLocation();

 // Effect for initial load and scroll logic
 useEffect(() => {
  setIsVisible(true);
  window.scrollTo(0, 0); 

  const handleScroll = () => {
   setIsScrolled(window.scrollY > 50);
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
 }, []);

 // Effect for rotating background images every 5 seconds
 useEffect(() => {
  const interval = setInterval(() => {
   setCurrentImageIndex(prevIndex => (prevIndex + 1) % bgImages.length);
  }, 5000); 

  return () => clearInterval(interval); 
 }, []);

 // Navigation handler using React Router
 const handleNavigation = (itemId) => {
  if (itemId === 'home') {
   window.scrollTo({ top: 0, behavior: 'smooth' });
   navigate('/');
  } else {
   navigate(`/${itemId}`);
  }
  // Mobile menu close logic removed
 };

 const currentImage = bgImages[currentImageIndex];
 const animationDirection = currentImageIndex % 2 === 0 ? 'slide-left' : 'slide-right';

 // Determine active status for navigation links
 const isLinkActive = (itemId) => {
  if (itemId === 'home') {
   return location.pathname === '/';
  }
  return location.pathname.startsWith(`/${itemId}`);
 };

 return (
  <div className="home-container">
   
   {/* 1. HEADER (Mobile Menu Removed, Desktop Nav Expanded) */}
   <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
    <div className="header-content">
      <img src="/assets/Construction Logo (4).png" alt="S&L Construction Logo" className="header-logo" />
     
     {/* Logo */}
     <div className="logo" onClick={() => handleNavigation('home')}>
      S&L Construction, Inc.
     </div>

     {/* Desktop Navigation (Will now adapt for mobile via CSS) */}
     <nav className="nav-desktop"> 
      {navItems.map(item => (
       <button
        key={item.id}
        onClick={() => handleNavigation(item.id)}
        className={`nav-link ${isLinkActive(item.id) ? 'active' : ''}`}
       >
        {item.label}
       </button>
      ))}
     </nav>

     {/* Phone CTA */}
     <a href="tel:8884642289" className="header-phone">
      <Phone size={18} />
      (312) 607-7476
     </a>

     {/* Mobile menu button REMOVED */}
    </div>

    {/* Mobile navigation block REMOVED */}
   </header>

   {/* 2. HERO SECTION */}
   <div 
    className={`hero-section ${animationDirection}`} 
    key={currentImageIndex} 
    style={{ backgroundImage: `url(${currentImage})` }}
   >
    <div className="hero-overlay"></div>
    <div className={`hero-content ${isVisible ? 'fade-in' : ''}`}>
     <h1 className="hero-title">
      Crafting Bespoke Homes & Spaces That Inspire
     </h1>
     <p className="hero-subtitle">
      Specializing in custom remodeling and building solutions tailored to your lifestyle.
     </p>
     <div className="cta-buttons">
      <a href="tel:8884642289" className="cta-primary">
       <Phone size={20} />
       Call Us Now — (312) 607-7476
      </a>
      <button onClick={() => handleNavigation('contact')} className="cta-secondary">
       <FileText size={20} />
       Request a Consultation Online
      </button>
     </div>
    </div>
   </div>
   
   {/* 4. FOOTER */}
   <footer className="footer-section">
    <div className="footer-content">
     <p className="footer-copy">© 2025 S&L Construction, Inc. | All Rights Reserved</p>
     <a href="tel:8884642289" className="footer-phone">
      <Phone size={16} />
      Call Us: (312) 607-7476
     </a>
    </div>
   </footer>
  </div>
 );
};

export default Home;